<template>
  <v-form ref="form" @submit.prevent="onCreateExport">
    <v-card tile>
      <v-card-title class="grey lighten-2">Dagrapport</v-card-title>

      <v-card-text class="mt-2">
        <v-row>
          <v-col cols="12">
            <ReportDateTime date-header="Trafikdygn" date-only v-model="date" />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer />
        <v-btn rounded @click="onClose" :disabled="loading">Avbryt</v-btn>
        <v-btn rounded type="submit" color="primary" :loading="loading"
          >Hämta</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import gql from 'graphql-tag'
import { format, addDays } from 'date-fns'
import ReportDateTime from './ReportDateTime'
import { generateAndDownloadDailyReport } from './exportGenerator'

export default {
  name: 'daily-report',

  components: {
    ReportDateTime
  },

  data() {
    return {
      loading: false,
      date: format(addDays(new Date(), -1), 'yyyy-MM-dd HH:mm')
    }
  },

  methods: {
    async onCreateExport() {
      this.loading = true
      const fileName = `Dagrapport ${this.date.substr(0, 10)}`

      const d = new Date(this.date)
      const from = (format(d, 'yyyy-MM-dd 04:15:00.000') + 'Z').replace(
        ' ',
        'T'
      )
      const to = (format(d, 'yyyy-MM-dd 15:15:00.000') + 'Z').replace(' ', 'T')

      const resp = await this.$apollo.query({
        query: gql`
          query dailyReport($filter: DailyReportInput!) {
            dailyReport(filter: $filter)
          }
        `,
        variables: {
          filter: {
            from,
            to
          }
        }
      })

      await generateAndDownloadDailyReport(fileName, resp.data.dailyReport)
      this.loading = false
      this.onClose()
    },
    onClose() {
      this.$emit('close')
    }
  }
}
</script>
